// 게시글 불러오기
import {apiClient} from "@/services/api/apiClient";
import {getCookie, setCookieMinutes} from "@/utils/cookieUtils";

export const fetchBoardData = async (boardTypes, page, pageSize, sort) => {
    console.log(sort)
    try {
        const response = await apiClient.get('/boards', {
            params: {
                boardCategories: 'YOUNG_ADULTS',
                boardTypes: boardTypes ? boardTypes.join(',') : '',
                page,
                pageSize,
                sort: 'createdAt,DESC'
            }
        });
        return response.data;
    } catch (error) {
        console.error('API 호출 실패:', error);
        throw error;
    }
};

export const fetchBoardOne = async (id) => {

    let plusViews = false;

    if (typeof window !== 'undefined') {
        const cookieKey = `board_viewed_${id}`;
        const alreadyViewed = getCookie(cookieKey);
        plusViews = !alreadyViewed;

        if (plusViews) {
            setCookieMinutes(cookieKey, 'true', 30); // 10분 유지
        }
    }

    try {
        const response = await apiClient.get(`/boards/${id}`, {
            params: {
                plusViews
            }
        });
        return response.data;
    } catch (error) {
        console.error('API 호출 실패:', error);
        throw error;
    }
};